import { enableLog, fetchSurvey } from '@/utils/tools'
import { Code, RespGetSurvey } from '@/types'
import { computed, onBeforeMount, ref } from 'vue'
import { useRoute } from 'vue-router'
// import { showFailToast } from 'vant'
import { useCode } from './useCode'
const WHITE_LIST = ['localhost', 'operation']
const onListener = (fn: any) => {
  window.addEventListener('message', function (event) {
    const { origin } = event
    if (!WHITE_LIST.some((item) => origin.includes(item))) return
    if (event.data?.type === 'survey_preview') {
      fn(event.data.data)
    }
    if (event.data?.type === 'ping') {
      event.source?.postMessage(
        {
          type: 'pong',
        },
        {
          targetOrigin: origin,
        }
      )
    }
  })
}

export function useFetchSurvey() {
  const route = useRoute()
  // const router = useRouter()
  const loading = ref<boolean>(false)
  // 判断是不是NaN
  const survey_conf_id = ref<string>(route.params.id as string) // 问卷id
  const survey = ref<RespGetSurvey>()
  const surveyInfo = computed<any[]>(() => {
    if (!survey.value) {
      return []
    }
    const conf = survey.value?.conf.survey
    if (!conf) return []
    try {
      const questions = JSON.parse(conf)?.questions ?? []
      return questions.map((item: any, index: number) => {
        return {
          ...item,
          index: index + 1,
          content: JSON.parse(item.content),
        }
      })
    } catch (error) {
      return []
    }
  })
  if (enableLog()) {
    console.log('survey', surveyInfo)
  }
  const isPreview = computed(() => {
    return route.name === 'Preview'
  })
  const { handleCode } = useCode()
  onBeforeMount(async () => {
    if (isPreview.value) {
      onListener((data: any) => {
        survey.value = data
      })
      return
    }
    loading.value = true
    const response = await fetchSurvey(survey_conf_id.value)
      .finally(() => {
        loading.value = false
      })
      .catch((err) => {
        if (enableLog()) {
          console.log('err', err)
        }
        throw new Error(err.message || ' 网络请求失败')
      })
    const header = response.header
    if (enableLog()) {
      console.log('response', response)
    }

    if (header?.code === Code.NORMAL) {
      survey.value = response.data as unknown as RespGetSurvey
      return ''
    }
    handleCode(header?.code as Code, header?.msg as string)
    // if (hit === false) {
    //   router.replace({
    //     name: 'error',
    //     query: {
    //       msg: encodeURIComponent(response.header?.msg || 'error'),
    //     },
    //   } as any)
    //   // showFailToast({
    //   //   message: header?.msg,
    //   //   duration: 3000,
    //   // })
    // }
  })
  return {
    survey,
    surveyInfo,
    survey_conf_id,
    loading,
  }
}
